function render(props) {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 600 600">
      <path d="M564.7,365.1h-25.4l-36.2-135.7h0s0,0,0,0h-145.3l47.6-82.4h-70.1V19.8h-70.4v127.2h-70.1l47.6,82.4H97.2l-36.2,135.7h-25.4c-9.1,0-16.5,7.4-16.5,16.5v182.7c0,9.1,7.4,16.5,16.5,16.5h529.2c9.1,0,16.5-7.4,16.5-16.5v-182.7c0-9.1-7.4-16.5-16.5-16.5ZM428.8,522.7H171.4v-65.9h37v42h183.4v-42h37v65.9ZM82,365.1l31.8-119.1h138.2l48.1,83.3,48.1-83.3h138.2l31.8,119.1H82Z" />
    </svg>
  );
}
export default render;
